"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=SuggestionsItem.types.js.map